import Skeleton from '@/common/helios/Skeleton';
import { useDeviceType } from '~/context/common/DeviceContext';
import { useIsNewVehicle } from '~/context/vdp/VehicleContext';
import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import { usePriceDrop } from '~/hooks/vdp';
import useIsPriceLoading from '~/hooks/vdp/selectors/useIsPriceLoading';
import useShowMiniHeroInfoCard from '~/hooks/vdp/useShowMiniHeroInfoCard';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import NewVehiclePrice from './NewVehiclePrice';
import { PriceWrapper, StyledPrice } from './Price.styles';
import PriceDrop from './PriceDrop';
import PriceWithDiscount from './PriceWithDiscount';

export default function Price() {
  const { finalPrice } = useVehiclePrice();
  const { isDesktop } = useDeviceType();
  const isLoading = useIsPriceLoading();
  const isNewVehicle = useIsNewVehicle();
  const priceKey = useKeyWithInterval();
  const showMiniHeroInfoCard = useShowMiniHeroInfoCard();
  const { showPriceDrop } = usePriceDrop();

  if (isLoading) {
    return (
      <Skeleton height={isDesktop ? 32 : 26} width={isDesktop ? 115 : 100} />
    );
  }

  if (showMiniHeroInfoCard) {
    return (
      <PriceWrapper>
        <StyledPrice key={priceKey}>
          ${formatAndDropDecimal(finalPrice)}
        </StyledPrice>
      </PriceWrapper>
    );
  }

  if (isNewVehicle) {
    return <NewVehiclePrice />;
  }

  if (showPriceDrop) {
    return <PriceDrop />;
  }

  return <PriceWithDiscount />;
}
